import AppButton from "@/features/line-sheet-sets/app-button";
import { Icon, Flex, Text, ChakraProps } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import { useMemo, useState } from "react";
interface AppCheckBoxProps {
  isChecked?: boolean;
  isDisabled?: boolean;
  isIndeterminate?: boolean;
  size?: "small" | "medium" | "large";
  alignSelf?: string;
  marginRight?: ChakraProps["marginRight"];
  name?: string;
  onChange?: (checked: boolean) => void;
  labelFontSize?: string;
}
export default function AppCheckBox({
  isChecked = false,
  isDisabled = false,
  isIndeterminate = false,
  alignSelf,
  marginRight,
  size = "medium",
  name,
  onChange,
  labelFontSize = "12px",
}: AppCheckBoxProps) {
  const [isHovered, setIsHovered] = useState(false);

  const sizeStyle = useMemo((): ChakraProps | undefined => {
    if (size === "medium") {
      return {
        w: "20px",
        h: "20px",
      };
    } else if (size === "small") {
      return {
        w: "16px",
        h: "16px",
      };
    }
  }, [size]);

  const icon = useMemo(() => {
    if (isChecked) {
      return (
        <Icon
          as={SVG}
          src={"/icons-v1_1/check.svg"}
          boxSize={"12px"}
          color={isHovered ? "#1272EF" : "#444440"}
          width={"20px"}
          height={"20px"}
        />
      );
    } else if (isIndeterminate) {
      return (
        <Icon
          as={SVG}
          src={"/icons-v1_1/minus.svg"}
          boxSize={"12px"}
          color={isHovered ? "#1272EF" : "#444440"}
          width={"20px"}
          height={"20px"}
        />
      );
    }
  }, [isChecked, isIndeterminate, isHovered]);

  return (
    <Flex
      flexDirection={"row"}
      alignItems={"center"}
      gap={"8px"}
      width={"fit-content"}
      cursor={isDisabled ? "default" : "pointer"}
      onClick={() => !isDisabled && onChange && onChange(!isChecked)}
    >
      <AppButton
        size={"small"}
        isDisabled={isDisabled}
        variant={"white"}
        chakraProps={{
          p: "4px",
          minW: "0px",
          alignSelf: alignSelf,
          marginRight: marginRight,
          flexShrink: "0",
          ...sizeStyle,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {icon}
      </AppButton>
      {name && <Text fontSize={labelFontSize}>{name}</Text>}
    </Flex>
  );
}
